import styles from "../../../styles/service/product-details.module.scss";
import classNames from "classnames/bind";

import { QuestionItem } from "./QuestionItem";
import { Checkbox } from "@components";
import { Currency } from "shared/utils/Currency";
import { findQuestion, updateQuestionInItems } from "./Step";

const css = classNames.bind(styles);

export default function Drink({ localProduct, activeStep, onProductChange }) {
  const renderSizesSection = () => (
    <>
      <div className={styles.sectionHeader}>
        <p className={styles.title}>Tamanho</p>
        <span className={styles.selectQuantity}>Selecione 1</span>
      </div>
      <div className={styles.options}>
        {localProduct.sizes.map((size, sizeIndex) => (
          <div
            key={sizeIndex}
            className={css({ option: true, selected: size.selected })}
            onClick={() => {
              localProduct.sizes.forEach((s) => (s.selected = false));
              localProduct.sizes[sizeIndex].selected = true;
              onProductChange({ sizes: localProduct.sizes });
            }}
          >
            <div className="d-flex flex-column">
              <p className={styles.name}>{size.name}</p>
              <div className="d-flex align-center gap-5">
                <span className={styles.price}>
                  {Currency.formatCurrency(size.price)}
                </span>
                {size.promo_price && (
                  <strike className={styles.fromPrice}>
                    {Currency.formatCurrency(size.old_price)}
                  </strike>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const renderActiveQuestion = () => {
    const question = findQuestion(localProduct.items, activeStep);
    if (!question) return null;

    return (
      <QuestionItem
        question={question}
        onChange={(updatedQuestion) => {
          const newItems = updateQuestionInItems(
            localProduct.items,
            activeStep,
            updatedQuestion,
          );
          onProductChange({ items: newItems });
        }}
        onCompletedQuestion={() => {}}
      />
    );
  };

  const renderExtrasSection = () => {
    const currentSize = localProduct.sizes.find((s) => s.selected);
    const extras = localProduct.extra_ingredients.map((extra) => {
      const extraSize = extra.sizes?.find(
        (size) => size.ref_id === currentSize?.ref_id,
      );
      return {
        ...extra,
        sku: extraSize?.sku || extra.sku,
        price: extraSize?.price || extra.price,
        originalPrice: extraSize?.originalPrice || extra.originalPrice,
      };
    });

    return (
      <>
        <div className={styles.sectionHeader}>
          <p className={styles.title}>Ingredientes extras</p>
        </div>
        <div className={styles.options}>
          {extras.map((e, eIndex) => (
            <div
              className={styles.option}
              key={eIndex}
              onClick={() => {
                extras[eIndex].selected = !extras[eIndex].selected;
                onProductChange({ extra_ingredients: extras });
              }}
            >
              <div className="d-flex flex-column">
                <p className={styles.name}>{e.name}</p>
                <div className="d-flex align-center mt-10">
                  <span className={styles.price}>
                    {Currency.formatCurrency(e.price)}
                  </span>
                </div>
              </div>
              <Checkbox
                value={e.name}
                checked={e.selected}
                key={`extraingredient-${e.id}`}
              />
            </div>
          ))}
        </div>
      </>
    );
  };

  if (!localProduct || !activeStep) return null;

  return (
    <>
      {activeStep === "sizes" && renderSizesSection()}
      {activeStep !== "sizes" &&
        activeStep !== "extras" &&
        renderActiveQuestion()}
      {activeStep === "extras" && renderExtrasSection()}
    </>
  );
}
